import React from 'react';
import { Card, CardText } from 'react-toolbox/lib/card';
import ProgressBar from 'react-toolbox/lib/progress_bar';
import spinnerTheme from '../LoadingOverlay/loadingTheme.css';
import styles from './LoadingView.css';

export default class LoadingCard extends React.PureComponent {
  render() {
    return (
      <div className={styles.container}>
        <Card className={styles.card}>
          <CardText className={styles.cardTitle}>
            <ProgressBar
              type="circular"
              mode="indeterminate"
              multicolor
              className={spinnerTheme.progressBar}
              theme={spinnerTheme}
            />
            <div className={styles.label}>Loading...</div>
          </CardText>
        </Card>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/LoadingView/index.js